<template>
  <div v-if="links && links.length > 0"
    :class="`flex gap-2 flex-wrap text-[12.3px] xs:text-[13px] md:text-[15px] ${!removePadding ? 'pt-5 pb-6 md:py-8' : ''} transition-colors duration-150 text-[#b4b4b4]`">
    <span v-for="(linkItem, index) in links" :key="linkItem.path" class="flex gap-2">
      <span
      v-if="linkItem.isButton"
      @click="linkItem.fun"
      :class="`${links.length - 1 === index ? 'active-link' : 'hover:text-[#222]/60'} cursor-pointer transition-colors duration-150`.trim()"

      >{{ linkItem.text }}</span>
      <NuxtLink v-else-if="links.length - 1 !== index && linkItem.path"
        :class="`${links.length - 1 === index ? 'active-link' : 'hover:text-[#222]/60'} transition-colors duration-150`.trim()"
        :to="linkItem.path" :title="linkItem.hoverTitle || ''">{{ linkItem.text }}</NuxtLink>
      <span v-else :class="`${links.length - 1 === index ? 'active-link' : ''}`">{{ linkItem.text }}</span>
      <ChevronLeft v-if="links.length - 1 !== index" :class="`${!isRightToLeft ? 'rotate-180' : ''}`" />
    </span>
  </div>
</template>

<script>
import { lowerString } from "@/helpers";
import ChevronLeft from "@/assets/shared/icons/ChevronLeft.vue";

export default {
  name: "breadcrumb",
  components: {
    ChevronLeft,
  },
  props: {
    links: {
      type: Array,
      required: true,
      default: () => []
    },
    removePadding: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isRightToLeft() {
      if (!process.client) {
        return false;
      }
      return lowerString(this.currentlySelectedLanguage) == "ar";
    }
  },
};
</script>
<style scoped>
.active-link {
  color: var(--primary-lighter-clr);
  font-weight: 600;
}
</style>
